/**
 * Fallback AI assistant panel on pages without a specialized flow.
 * Composer and prompt chips stay in treatment-plan and progress-note flows only.
 */

import { ScrollArea, Stack } from '@mantine/core';

import { ChatMessageBubble } from './ChatMessageBubble';

export const GENERAL_CHAT_INTRO_MESSAGE =
  'Freud is currently available only for treatment plans and AI note generation. '
  + 'Open a client’s treatment plan or a session note and I’ll pick up that context automatically.';

export function GeneralChatFlow(): JSX.Element {
  return (
    <Stack gap={0} h="100%" style={{ minHeight: 0 }}>
      <ScrollArea type="auto" style={{ flex: 1, minHeight: 0 }}>
        <Stack gap="md" p="md" role="log" aria-label="AI assistant conversation">
          <ChatMessageBubble role="assistant" text={GENERAL_CHAT_INTRO_MESSAGE} />
        </Stack>
      </ScrollArea>
    </Stack>
  );
}
